import { createPatch } from 'rfc6902';
import { uuidv7 } from 'uuidv7';
import { PatientTherapySequenceStatus } from '../../database/schema.js';
import { EventLogs } from '../../utils.js';
import { addEventLog, EventLogResources } from '../util.js';
/** Where a released preparation goes: Administered when the nurse step is skipped, otherwise Released for delivery. */
export function getDispatchStatus(settings) {
    return settings?.markAdministeredOnDispatch
        ? PatientTherapySequenceStatus.enum.administered
        : PatientTherapySequenceStatus.enum.released_for_delivery;
}
/**
 * Auto-release for delivery (Settings > Workflow) skips QA & dispatch. The release is still logged as its own
 * RELEASE_FOR_DELIVERY status change, marked automatic, so the activity log and the production report's
 * Released by show it.
 */
export async function logAutomaticRelease(tx, params) {
    if (tx.location !== 'server')
        return;
    await addEventLog(tx, {
        id: uuidv7(),
        resource: EventLogResources.patientTherapySequence,
        resourceId: params.sequenceId,
        action: 'update',
        domain: 'prescription',
        event: EventLogs.PRESCRIPTION_STATUS_CHANGE,
        patches: createPatch({ status: PatientTherapySequenceStatus.enum.qa_dispatch }, { status: params.status }),
        performedBy: params.userId,
        performedAt: params.now,
        details: {
            therapyInternalId: params.therapyInternalId ?? '',
            action: 'RELEASE_FOR_DELIVERY',
            automatic: 'true',
        },
    });
}
//# sourceMappingURL=auto-release.js.map